// clean-beauty.js
document.addEventListener("DOMContentLoaded", function() {
  initializeAllCleanBeautySections();
});

function initializeAllCleanBeautySections() {
  const beautySections = document.querySelectorAll(".cstm_beauty_section_wrapper");
  
  if (beautySections.length === 0) return;
  
  console.log(`Found ${beautySections.length} clean beauty sections`);
  
  beautySections.forEach((section, index) => {
    console.log(`Initializing clean beauty section ${index + 1}`);
    initializeCleanBeautySection(section);
  });
}

function initializeCleanBeautySection(sectionElement) {
  if (!sectionElement) return;

  const tabs = sectionElement.querySelectorAll(".tab-button");
  const productGrids = sectionElement.querySelectorAll(".products-grid");
  const collectionImages = sectionElement.querySelectorAll(".collection-image");
  const viewAllLink = sectionElement.querySelector(".view-all-current");

  // Initialize tabs functionality
  tabs.forEach(tab => {
    // Remove existing onclick handlers and use event listeners
    tab.removeAttribute('onclick');
    
    tab.addEventListener("click", function(event) {
      const collectionHandle = this.dataset.collection;
      const sectionId = sectionElement.id.replace('clean-beauty-', '');
      
      switchCollection(event, sectionElement, collectionHandle);
    });
  });

  // Initialize variant selects
  initializeCleanBeautyVariantSelects(sectionElement);

  // Initialize add to cart forms
  initializeCleanBeautyAddToCartForms(sectionElement);

  // Initialize prices on load
  initializeCleanBeautyPrices(sectionElement);
}

function switchCollection(event, sectionElement, collectionHandle) {
  // Update active tab
  sectionElement.querySelectorAll('.tab-button').forEach(btn => {
    btn.classList.remove('active');
  });
  event.target.classList.add('active');
  
  // Update product grids
  sectionElement.querySelectorAll('.products-grid').forEach(grid => {
    grid.classList.remove('active');
  });
  
  const targetGrid = sectionElement.querySelector('.products-grid-' + collectionHandle);
  if (targetGrid) {
    targetGrid.classList.add('active');
  }
  
  // Update collection images
  sectionElement.querySelectorAll('.collection-image').forEach(img => {
    img.style.display = 'none';
  });
  
  const targetImage = sectionElement.querySelector('.collection-image-' + collectionHandle);
  if (targetImage) {
    targetImage.style.display = 'block';
  }
  
  // Update view all link
  const viewAllLink = sectionElement.querySelector('.view-all-current');
  if (viewAllLink) {
    viewAllLink.href = '/collections/' + collectionHandle;
  }
  
  // Re-initialize variant selects and prices for the newly active tab
  setTimeout(() => {
    initializeCleanBeautyVariantSelects(sectionElement);
    initializeCleanBeautyPrices(sectionElement);
  }, 50);
}

function initializeCleanBeautyVariantSelects(sectionElement) {
  const variantSelects = sectionElement.querySelectorAll('.variant-select');
  
  variantSelects.forEach(select => {
    // Remove existing onchange handlers and use event listeners
    select.removeAttribute('onchange');
    
    select.addEventListener('change', function() {
      updateCleanBeautyVariant(this, this.dataset.productId);
    });
  });
}

function initializeCleanBeautyPrices(sectionElement) {
  const variantSelects = sectionElement.querySelectorAll('.variant-select');
  
  variantSelects.forEach(select => {
    // Initialize current price for each select
    updateCleanBeautyVariantPrice(select, select.dataset.productId);
  });
}

function updateCleanBeautyVariant(selectElement, productId) {
  const selectedVariantId = selectElement.value;
  const productCard = selectElement.closest('.product-card');
  
  if (!productCard) {
    console.error('Product card not found');
    return;
  }
  
  // Update variant input
  const variantInput = productCard.querySelector('.variant-id-' + productId);
  if (variantInput) {
    variantInput.value = selectedVariantId;
    console.log('Updated variant input to:', selectedVariantId);
  }
  
  // Update price
  updateCleanBeautyVariantPrice(selectElement, productId);
}

function updateCleanBeautyVariantPrice(selectElement, productId) {
  const productCard = selectElement.closest('.product-card');
  if (!productCard) return;

  const priceElement = productCard.querySelector('.price');
  if (!priceElement) {
    console.error('Price element not found');
    return;
  }

  // Find the selected option to get the price
  const selectedOption = selectElement.options[selectElement.selectedIndex];
  
  // Update price if data-price attribute exists
  if (selectedOption && selectedOption.dataset.price) {
    console.log('Updating price to:', selectedOption.dataset.price);
    priceElement.textContent = selectedOption.dataset.price;
    
    // Force a DOM update
    priceElement.style.display = 'none';
    priceElement.offsetHeight; // Trigger reflow
    priceElement.style.display = '';
  } 
  // Fallback to API call if no data-price
  else {
    const selectedVariantId = selectElement.value;
    console.log('No data-price, fetching variant data for:', selectedVariantId);
    
    const originalPrice = priceElement.textContent;
    priceElement.textContent = 'Loading...';
    
    fetch(`/variants/${selectedVariantId}.js`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Variant not found');
        }
        return response.json();
      })
      .then(variant => {
        // Use Shopify's money format or fallback
        let formattedPrice;
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
          formattedPrice = Shopify.formatMoney(variant.price, window.moneyFormat || "{{ shop.money_format | escape }}");
        } else {
          // Fallback formatting
          formattedPrice = '$' + (variant.price / 100).toFixed(2);
        }
        priceElement.textContent = formattedPrice;
        console.log('Price updated via API to:', formattedPrice);
      })
      .catch(error => {
        console.error('Error fetching variant:', error);
        priceElement.textContent = originalPrice;
      });
  }
}

function initializeCleanBeautyAddToCartForms(sectionElement) {
  const forms = sectionElement.querySelectorAll('.add-to-cart-form');
  
  forms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      handleCleanBeautyAddToCart(this);
    });
  });
}

function handleCleanBeautyAddToCart(form) {
  const formData = new FormData(form);
  const button = form.querySelector('.add-to-cart-btn');
  const originalText = button.textContent;
  
  button.textContent = 'Adding...';
  button.disabled = true;
  
  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(data => {
    button.textContent = 'Added!';
    setTimeout(() => {
      button.textContent = originalText;
      button.disabled = false;
    }, 2000);
    
    // Update cart count if you have a cart drawer
    if (typeof window.updateCartCount === 'function') {
      window.updateCartCount();
    }
  })
  .catch(error => {
    console.error('Error:', error);
    button.textContent = 'Error';
    setTimeout(() => {
      button.textContent = originalText;
      button.disabled = false;
    }, 2000);
  });
}

// Additional initialization as backup
setTimeout(() => {
  initializeAllCleanBeautySections();
}, 1500);